import { SnowplowService } from 'wanderu-service-analytics';

function directionsLinkOpened({ tripId, stationId, eventCategory }) {
    SnowplowService.fireStructuredEventWithBatchId({
        category: eventCategory,
        action: 'click',
        label: 'view_station_map',
        property: {
            trip_id: tripId,
            station_id: stationId,
        },
    });
}

export default {
    directionsLinkOpened,
};
